import { useRef, useContext, useState, useEffect } from 'react';
import styles from './AddMembersComponent.module.css'

import { GlobalContext } from "../../../contexts/globalContext";
import { ProjectDetailsContext } from '../../../contexts/projectDetailsContext';

import { byPrefixAndName } from '@awesome.me/kit-fe6b9b7683/icons';

import PopupHeaderComponent from '../common/PopupHeaderComponent';
import PopupBodyComponent from '../common/PopupBodyComponent';
import PopupBaseComponent from '../common/PopupBaseComponent';
import ClosePageButtonComponent from '../../commons/ClosePageButtonComponent'
import RightBodyComponent from '../common/RightBodyComponent';
import LeftBodyComponent from '../common/LeftBodyComponent';
import FooterButtonsComponent from '../common/FooterButtonsComponent';
import CustomDropdownComponent from '../../commons/CustomDropdownComponent';
import New_InputTextComponent from '../../keyboard/New_InputTextComponent';
import New_DropDownComponent from '../../keyboard/New_DropDownComponent';

import CountriesJson from '../../../graphics/country.json';
import membersAdd from '../../../graphics/Popups/Icon Members Add.png'

const AddMembersComponent = () => {

    const { language, selectedProject, socketRef, departmentList, functionList, setAlertMessage, keyboardRef, currentUser } = useContext(GlobalContext);
    const { setAddMembers, setAddParticipants } = useContext(ProjectDetailsContext);

    const inputRefName = useRef()
    const inputRefEmail = useRef()
    const inputRefPass = useRef()
    const inputRefPassConf = useRef()
    const inputRefCountry = useRef()

    const [checkInputs, setCheckInputs] = useState(false)
    const [currentChoiceDepartment, setCurrentChoiceDepartment] = useState({})
    const [currentChoiceFunction, setCurrentChoiceFunction] = useState({})
    const [optionsDepartmentList, setOptionsDepartmentList] = useState({})
    const [optionsFunctionList, setOptionsFunctionList] = useState({})

    useEffect(() => {
        socketRef.current.emit("GET_ALL_DEPARTMENTS", (callback) => {
            const list = callback.map(item => ({ value: item.code, text: item.name }));
            setOptionsDepartmentList(list)
            setCurrentChoiceDepartment(list[0]);
        });

        socketRef.current.emit("GET_ALL_FUNCTIONS", (callback) => {
            const list = callback.map(item => ({ value: item.code, text: item.name }));
            setOptionsFunctionList(list)
            setCurrentChoiceFunction(list[0]);
        });
    }, []);


    const allFieldsCompleted = () => {
        const name = inputRefName.current?.value?.trim() || "";
        const email = inputRefEmail.current?.value?.trim() || "";
        const password = inputRefPass.current?.value?.trim() || "";
        const confirmPassword = inputRefPassConf.current?.value?.trim() || "";

        return (
            name.length > 0 &&
            email.length > 0 &&
            password.length > 0 &&
            confirmPassword.length > 0
        );
    };

    const handleInputChange = () => {
        if (allFieldsCompleted()) {
            setCheckInputs(true)
        }
    }

    function handleEmailAdd() {
        let memberFunction = functionList.find(func => func.code === currentChoiceFunction.value)
        let memberDepartment = departmentList.find(dep => dep.code === currentChoiceDepartment.value)

        if (inputRefPass.current.value === inputRefPassConf.current.value) {
            socketRef.current.emit("CREATE_USER_AND_ADD_TO_PROJECT", {
                projectId: selectedProject._id,
                userData: {
                    "name": inputRefName.current.value,
                    "email": inputRefEmail.current.value,
                    "password": inputRefPass.current.value,
                    "function_id": memberFunction._id,
                    "department_id": memberDepartment._id,
                    "role": "MEMBER",
                    "country": inputRefCountry.current.currentChoice?.value ? inputRefCountry.current.currentChoice.value : null,
                    "creatorLocationId": currentUser.location ? currentUser.location : null
                }
            }, (callback) => {
                if (callback){
                    setAddMembers(false)
                    setAddParticipants(false)
                    setAlertMessage({ type: "SUCCESS", message: "Member created and added to project successfully." });
                }
            })
        } else {
            setAlertMessage({ type: "ERROR", message: "Passwords do not match. Please ensure password and Confirm Password fields are identical." });

        }
    }


    return (
        <PopupBaseComponent>
            <PopupHeaderComponent text={language.add_guests['Add Guest']} />
            <PopupBodyComponent style={{ width: 2700, height: 940, top: "12%" }}>
                <ClosePageButtonComponent setClose={() => setAddMembers(false)} />
                <LeftBodyComponent givenWidth="800px" image={membersAdd} title="Add member to project" description="Create and add a new member. You will automatically add this as a member in the organization, as well as a member to the project." />
                <RightBodyComponent>
                    <div className={styles.title}>New Member</div>

                    <div className={styles.bodyDetails}>
                        <div className={styles.column}>
                            <div className={styles.subTitle}>Name</div>
                            <New_InputTextComponent ref={inputRefName} keyboardRef={keyboardRef} value="" icon={byPrefixAndName.fas["pen"]} iconPosition="right" withDelete={true}
                                placeHolder="Enter name here" styleType='POPUP' width="800px" height="80px" fontSize="40px" onChange={handleInputChange} />

                            <div className={styles.subTitle}>Password</div>
                            <New_InputTextComponent type="password" ref={inputRefPass} keyboardRef={keyboardRef} value="" placeHolder="Enter password here" iconPosition="right" withDelete={true}
                                onChange={handleInputChange} styleType='POPUP' width="800px" height="80px" fontSize="40px" />

                            <div className={styles.subTitle}>Department</div>
                            <CustomDropdownComponent marginLeftText={10} style={{ marginLeft: 0, marginTop: 0 }} options={optionsDepartmentList} currentChoice={currentChoiceDepartment}
                                setCurrentChoice={setCurrentChoiceDepartment} width={806} />

                            <div className={styles.subTitle}>Country</div>
                            <New_DropDownComponent options={CountriesJson} ref={inputRefCountry} keyboardRef={keyboardRef} value="" placeHolder="Choose country" iconPosition="right" 
                                withDelete={true} styleType='POPUP' width="800px" height="80px" fontSize="40px" />
                        </div>

                        <div className={styles.column} style={{ paddingLeft: 40, position: "fixed", left: "calc(66%)" }}>
                            <div className={styles.subTitle}>Email</div>
                            <New_InputTextComponent ref={inputRefEmail} keyboardRef={keyboardRef} value="" placeHolder="Enter email here" iconPosition="right" withDelete={true}
                                onChange={handleInputChange} styleType='POPUP' width="800px" height="80px" fontSize="40px" icon={byPrefixAndName.fas["pen"]} />

                            <div className={styles.subTitle}>Confirm Password</div>
                            <New_InputTextComponent type={"password"} ref={inputRefPassConf} keyboardRef={keyboardRef} value="" placeHolder="Re-enter password here" iconPosition="right"
                                withDelete={true} onChange={handleInputChange} styleType='POPUP' width="800px" height="80px" fontSize="40px" />

                            <div className={styles.subTitle}>Function</div>
                            <CustomDropdownComponent marginLeftText={10} style={{ marginLeft: 0, marginTop: 0 }} options={optionsFunctionList} currentChoice={currentChoiceFunction}
                                setCurrentChoice={setCurrentChoiceFunction} width={806} />
                        </div>
                    </div>

                    <div style={{ marginLeft: 20 }}>
                        <FooterButtonsComponent
                            lightText={"Create"}
                            isOpaque={!checkInputs}
                            lightClick={checkInputs ? handleEmailAdd : () => { }}
                            darkClick={setAddMembers}
                        />
                    </div>

                </RightBodyComponent>
            </PopupBodyComponent>

        </PopupBaseComponent>
    );

}

export default AddMembersComponent;